import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFloorDetectionAutomatisch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "currentColor"
	},
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M17.309,11.24l0,7.8c0,0 -0.071,1.804 -1.574,1.917c-1.503,0.113 -12.084,0 -12.084,0c-0.943,0 -1.707,-0.812 -1.707,-1.822l0,-8.206c0,-0.538 0.222,-1.048 0.605,-1.388l5.966,-5.467c0.64,-0.576 1.565,-0.576 2.205,0l5.975,5.467c0.382,0.349 0.605,0.859 0.605,1.388",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.38px"
			}
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M4.417,11.24l10.59,0",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.38px"
			}
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M15.006,16.396l-10.59,-0.019",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.38px"
			}
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M20.885,3.33c0.119,0.269 0.329,0.488 0.597,0.607l1.135,0.508c0.339,0.159 0.339,0.637 0,0.797l-1.125,0.508c-0.269,0.119 -0.488,0.339 -0.597,0.607l-0.886,2.081c-0.159,0.329 -0.637,0.329 -0.797,0l-0.886,-2.081c-0.119,-0.269 -0.329,-0.488 -0.597,-0.607l-1.125,-0.508c-0.339,-0.159 -0.339,-0.637 0,-0.797l1.125,-0.508c0.269,-0.119 0.488,-0.339 0.597,-0.607l0.886,-2.081c0.159,-0.329 0.637,-0.329 0.797,0l0.876,2.081Z" }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M23.135,9.305c0,0.528 -0.418,0.966 -0.926,0.966c-0.508,0 -0.926,-0.428 -0.926,-0.966c0,-0.538 0.418,-0.966 0.926,-0.966c0.508,0 0.926,0.428 0.926,0.966Z" }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M15.09,2.922c0.518,0 0.926,-0.428 0.926,-0.966c0,-0.538 -0.408,-0.956 -0.926,-0.956c-0.518,0 -0.926,0.428 -0.926,0.966c0,0.538 0.418,0.966 0.926,0.966l0,-0.01Z" }) })
	]
});
export default SvgFloorDetectionAutomatisch;
